import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ApolloProvider } from '@apollo/client'
import { AuthProvider } from './hooks/useAuth'
import { client } from './services/apollo'

import {
  Admin,
  Agenda,
  AgendaDetail,
  ErrorPage,
  Forgot,
  Home,
  Leaderboard,
  LearningLounge,
  LearningLoungeDetail,
  Login,
  Profile,
  Register,
  Reset,
  TipsTools,
  TipsToolsDetail,
} from './pages'
import {
  RequireAuth,
  AdminNewOffering,
  AdminViewRegistrants,
  AdminUnlockContent,
  AdminEndOffering,
} from './components'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      // Public routes
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'register',
        element: <Register />,
      },
      {
        path: 'forgot',
        element: <Forgot />,
      },
      {
        path: 'reset',
        element: <Reset />,
      },
      // Protected routes
      {
        path: 'profile',
        element: (
          <RequireAuth>
            <Profile />
          </RequireAuth>
        ),
      },
      {
        path: 'leaderboard',
        element: (
          <RequireAuth>
            <Leaderboard />
          </RequireAuth>
        ),
      },
      {
        path: 'agenda',
        element: (
          <RequireAuth>
            <Agenda />
          </RequireAuth>
        ),
        children: [
          {
            path: ':day',
            element: <AgendaDetail />,
          },
        ],
      },
      {
        path: 'tipstools',
        element: (
          <RequireAuth>
            <TipsTools />
          </RequireAuth>
        ),
      },
      {
        path: 'tipstools/:title',
        element: (
          <RequireAuth>
            <TipsToolsDetail />
          </RequireAuth>
        ),
      },
      {
        path: 'learninglounge',
        element: (
          <RequireAuth>
            <LearningLounge />
          </RequireAuth>
        ),
      },
      {
        path: 'learninglounge/:title',
        element: (
          <RequireAuth>
            <LearningLoungeDetail />
          </RequireAuth>
        ),
      },
      {
        path: 'admin',
        element: (
          <RequireAuth>
            <Admin />
          </RequireAuth>
        ),
        children: [
          {
            path: 'new',
            element: <AdminNewOffering />,
          },
          {
            path: 'view',
            element: <AdminViewRegistrants />,
          },
          {
            path: 'unlock',
            element: <AdminUnlockContent />,
          },
          {
            path: 'end',
            element: <AdminEndOffering />,
          },
        ],
      },
    ],
  },
])

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <AuthProvider>
        <RouterProvider
          router={router}
          // fallbackElement={Spinner}
        />
      </AuthProvider>
    </ApolloProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
